import { useQuery } from "@tanstack/react-query"
import { client } from "@/api"

export interface ExportJob {
  job_id: string
  status: string
  progress: string | null
  frame_count: number | null
  updated_at: string
  email: string | null
  error: string | null
}

export type ExportJobStatusFilter = "all" | "running"

interface UseExportJobsOptions {
  limit?: number
  status?: ExportJobStatusFilter
  enabled?: boolean
}

export function useExportJobs({
  limit = 50,
  status = "all",
  enabled = true,
}: UseExportJobsOptions = {}) {
  return useQuery<ExportJob[]>({
    queryKey: ["admin", "export-jobs", { limit, status }],
    queryFn: async () => {
      const response = await client.admin["export-jobs"].$get({
        query: {
          limit: limit.toString(),
          status,
        },
      })

      if (!response.ok) {
        throw new Error(`Failed to fetch export jobs: ${response.status}`)
      }

      return response.json() as Promise<ExportJob[]>
    },
    enabled,
    // No refetchIntervalInBackground (2026-09-28 incident): installIdlePause
    // (@playside/tab-activity) already pauses this while the tab is hidden or idle.
    refetchInterval: 4000,
  })
}
